import React from 'react'

const Calculators = (props) => (
  <svg width={props.width ? props.width : "24"}
       height={props.height ? props.height : "24"}
       viewBox="0 0 24 24"
       fill={props.color ? props.color : "#97A3C7"}
       xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H21C21.5523 17 22 16.5523 22 16C22 15.4477 21.5523 15 21 15H15Z"
    />
    <path d="M15 19C14.4477 19 14 19.4477 14 20C14 20.5523 14.4477 21 15 21H21C21.5523 21 22 20.5523 22 20C22 19.4477 21.5523 19 21 19H15Z"
    />
    <path
      d="M4.20711 14.7929C3.81658 14.4024 3.18342 14.4024 2.79289 14.7929C2.40237 15.1834 2.40237 15.8166 2.79289 16.2071L4.58579 18L2.79289 19.7929C2.40237 20.1834 2.40237 20.8166 2.79289 21.2071C3.18342 21.5976 3.81658 21.5976 4.20711 21.2071L6 19.4142L7.79289 21.2071C8.18342 21.5976 8.81658 21.5976 9.20711 21.2071C9.59763 20.8166 9.59763 20.1834 9.20711 19.7929L7.41421 18L9.20711 16.2071C9.59763 15.8166 9.59763 15.1834 9.20711 14.7929C8.81658 14.4024 8.18342 14.4024 7.79289 14.7929L6 16.5858L4.20711 14.7929Z"
    />
    <path
      d="M17 9C17 9.55229 17.4477 10 18 10C18.5523 10 19 9.55229 19 9V7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H19V3C19 2.44772 18.5523 2 18 2C17.4477 2 17 2.44772 17 3V5H15C14.4477 5 14 5.44772 14 6C14 6.55228 14.4477 7 15 7H17V9Z"
    />
    <path d="M2 6C2 5.44772 2.44772 5 3 5H9C9.55228 5 10 5.44772 10 6C10 6.55228 9.55228 7 9 7H3C2.44772 7 2 6.55228 2 6Z" />
  </svg>
)

export default Calculators
